import type { TextFieldProps } from 'formik-mui';
import { TextField } from 'formik-mui';
import React from 'react';

export default (props: JSX.IntrinsicAttributes & TextFieldProps & { requiredField?: boolean }) => {
    const {
        requiredField, ...rest
    } = props;
    return (<TextField
        {...rest}
        aria-labelledby={props['aria-labelledby']}
        InputProps={{
            'inputProps': {
                'aria-label': props['aria-label'],
                'aria-labelledby': props['aria-labelledby'],
                'aria-describedby': `${props.field.name}-error-label`,
                'aria-required': requiredField,
            },
        }} />);
};
